import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {analyticsClient} from '../../../../analytics-client';

import {Intro, Reporting, Managing, Automating} from './pages';

export function AttributionOnboardingModal() {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.ATTRIBUTION_ONBOARDING_MODAL);

    const pages = [
        {
            id: 'Intro',
            body: <Intro />,
            art: {
                background: colors.plumLt,
                image: () => <ImageWrapper image={<Illustration src='channels' />} width={140} />,
            },
        },
        {
            id: 'Reporting',
            body: <Reporting />,
            art: {
                background: colors.plumLt,
                image: () => <ImageWrapper image={<Illustration src='reporting' />} width={210} />,
            },
        },
        {
            id: 'Managing',
            body: <Managing />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper image={<Illustration src='managing-sources' />} width={210} />
                ),
            },
        },
        {
            id: 'Automating',
            body: <Automating />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper image={<Illustration src='code-snippet' />} width={270} />
                ),
            },
        },
    ];

    return isOpen ? (
        <OnboardingModal
            trapFocus={false}
            lastButtonText='Close'
            pages={pages}
            onClose={onClose}
            onFinish={onClose}
            canClickOutsideToClose={false}
            analyticsClient={analyticsClient}
            getAnalyticsEventForPageView={getAnalyticsEventForPageView}
        />
    ) : (
        <></>
    );
}

const getAnalyticsEventForPageView = (pageNumber: number) => {
    switch (pageNumber) {
        case 0:
            return analyticsClient.EVENTS.TRACK_ATTRIBUTION_ONBOARDING_STARTED;
        case 3:
            return analyticsClient.EVENTS.TRACK_ATTRIBUTION_ONBOARDING_COMPLETED;
        default:
            return null;
    }
};
